import { StateType } from '@redux/reducers';

export const companiesFoldersSelector = ({ companies: { folders } }: StateType) => folders;
export const companiesFiltersSelector = ({ companies: { filters } }: StateType) => filters;
